import React from 'react';
import { sceneImages } from '../../data/images';
const rows = [{
  topic: 'Power',
  m1: 'Rechargeable internal battery, charged via USB-C.',
  conventional: 'Typically line-voltage or low-voltage wiring run to the pool.'
}, {
  topic: 'Installation',
  m1: 'Magnetic mounting. No drilling where the approved mounting method permits.',
  conventional: 'Often involves a wall niche, conduit and a licensed electrician.'
}, {
  topic: 'Housing',
  m1: 'ABS exterior — does not rust like exposed ferrous metal.',
  conventional: 'Varies by product and material.'
}, {
  topic: 'Flexibility',
  m1: 'Lift off the base to reposition or recharge.',
  conventional: 'Position fixed at the time of construction.'
}, {
  topic: 'Color',
  m1: 'RGB with 16 advertised color options.',
  conventional: 'Varies — many fixtures are single-color.'
}];
export function BuiltDifferent() {
  return <section aria-labelledby="built-title" className="relative overflow-hidden border-y mf-hairline bg-graphite" data-id="element-88" data-mp="2jf0lpmp2iuk3">
      <img src={sceneImages.waterTexture} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-89" data-mp="3qree3m6khfdv" />
      <div className="relative mx-auto max-w-site px-5 py-24 md:px-8 md:py-32" data-id="element-90" data-mp="3gvbd4jngbmsi">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-20" data-id="element-91" data-mp="3gxechuahus9w">
          <div data-id="element-92" data-mp="3cvkg3y7c0afj">
            <h2 id="built-title" className="font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-93" data-mp="3cw2m3mjsq30n">
              Built Different.
              <span className="block text-ice" data-id="element-94" data-mp="8fhwm4t4ebbg">Built for the Elements.</span>
            </h2>
            <p className="mt-6 max-w-md text-lg text-titanium" data-id="element-95" data-mp="3o9mt7nvonxr">
              Professional lighting without the complicated installation. Here's how the M1 PRO approach compares with a
              conventional hard-wired installation.
            </p>
          </div>

          <div className="overflow-x-auto" data-id="element-96" data-mp="renhl5xul0w1">
            <table className="w-full min-w-[560px] text-left" data-id="element-97" data-mp="rdkpiuosgsej">
              <caption className="sr-only" data-id="element-98" data-mp="2lmrbjxbnv20x">M1 PRO compared with conventional hard-wired pool lighting</caption>
              <thead data-id="element-99" data-mp="2qm3uw83bpqyr">
                <tr className="border-b border-titanium/25 text-sm" data-id="element-100" data-mp="2qkj4muo1ku6p">
                  <th scope="col" className="w-[22%] pb-4 font-medium text-titanium/70" data-id="element-101" data-mp="2bwy2b2yzqyzu"></th>
                  <th scope="col" className="pb-4 font-display text-lg font-semibold uppercase tracking-[0.08em] text-white" data-id="element-102" data-mp="2gvhmoyxxs2q3">
                    M1 PRO
                  </th>
                  <th scope="col" className="pb-4 font-display text-lg font-semibold uppercase tracking-[0.08em] text-titanium/70" data-id="element-103" data-mp="22yckxb599q0n">
                    Conventional hard-wired
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-104" data-mp="1xw3ou5x367ub">
                {rows.map(r => <tr key={r.topic} className="border-b mf-hairline align-top" data-id="element-105" data-mp="1xyq6wzhls5qs">
                    <th scope="row" className="py-5 pr-4 text-sm font-medium text-titanium" data-id="element-106" data-mp="3ncmldj94jdvd">
                      {r.topic}
                    </th>
                    <td className="py-5 pr-6 text-white" data-id="element-107" data-mp="1gn1h4ddg7qiy">{r.m1}</td>
                    <td className="py-5 text-titanium/80" data-id="element-108" data-mp="1gl85skrw4i4m">{r.conventional}</td>
                  </tr>)}
              </tbody>
            </table>
            <p className="mt-4 text-xs text-titanium/60" data-id="element-109" data-mp="1qe5sz47tuv9k">
              General comparison for illustration. Conventional products vary; no specific competitor is referenced.
            </p>
          </div>
        </div>
      </div>
    </section>;
}